export const RESEND_CONFIRMACC_REQUESTING = 'RESEND_CONFIRMACC_REQUESTING'
export const RESEND_CONFIRMACC_SUCCESS = 'RESEND_CONFIRMACC_SUCCESS'
export const RESEND_CONFIRMACC_ERROR = 'RESEND_CONFIRMACC_ERROR'
export const RESEND_CONFIRMACC_URL = '/api/v1/users/resend_confirm_regist'


// WEBPACK FOOTER //
// ./src/views/Pages/ResendConfirmAcc/constants.js